/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'ssl-certificate-grid-status-column';
const prefix = `${moduleName}.${componentName}`;

export const certificateStatusTooltipLabel = `${prefix}.certificateStatusTooltipLabel`;
export const expiringOnLabel = `${prefix}.expiringOnLabel`;

export const ENGLISH = {
    [certificateStatusTooltipLabel]: 'Status',
    [expiringOnLabel]: 'Expiring on',
};
